import { useState } from "react";

import { useAnimationFrame } from "framer-motion";

/**
 *
 * @param {import("react").Ref} ref - the ref of the element you're interested in.
 * @param {string} targetStyle - the style property you want to watch.
 * @returns {string}
 */
const useComputedStyle = (ref, targetStyle) => {
  const [value, setValue] = useState(
    ref?.current ? getComputedStyle(ref.current)[targetStyle] : ""
  );

  // Resize observer proved to be unreliable. Do not be fooled!
  useAnimationFrame(() => {
    if (typeof ref.current?.tagName !== "string") return;
    const newValue = getComputedStyle(ref.current)[targetStyle];
    if (value !== newValue) setValue(newValue || "");
  });

  return value;
};

export default useComputedStyle;
